export const GET_PRODUCTS_LIST_FOR_DPP_REQUEST =
  "GET_PRODUCTS_LIST_FOR_DPP_REQUEST";
export const GET_PRODUCTS_LIST_FOR_DPP_SUCCESS =
  "GET_PRODUCTS_LIST_FOR_DPP_SUCCESS";
export const GET_PRODUCTS_LIST_FOR_DPP_FAILURE =
  "GET_PRODUCTS_LIST_FOR_DPP_FAILURE";

export const GET_ALL_DATA_FOR_DPP_REQUEST = "GET_ALL_DATA_FOR_DPP_REQUEST";
export const GET_ALL_DATA_FOR_DPP_SUCCESS = "GET_ALL_DATA_FOR_DPP_SUCCESS";
export const GET_ALL_DATA_FOR_DPP_FAILURE = "GET_ALL_DATA_FOR_DPP_FAILURE";

export const GET_TECHNICAL_DOCUMENTS_REQUEST =
  "GET_TECHNICAL_DOCUMENTS_REQUEST";
export const GET_TECHNICAL_DOCUMENTS_SUCCESS =
  "GET_TECHNICAL_DOCUMENTS_SUCCESS";
export const GET_TECHNICAL_DOCUMENTS_FAILURE =
  "GET_TECHNICAL_DOCUMENTS_FAILURE";

export const GET_DURABILITY_REQUEST = "GET_DURABILITY_REQUEST";
export const GET_DURABILITY_SUCCESS = "GET_DURABILITY_SUCCESS";
export const GET_DURABILITY_FAILURE = "GET_DURABILITY_FAILURE";

export const GET_DPP_PARENT_REQUEST = "GET_DPP_PARENT_REQUEST";
export const GET_DPP_PARENT_SUCCESS = "GET_DPP_PARENT_SUCCESS";
export const GET_DPP_PARENT_FAILURE = "GET_DPP_PARENT_FAILURE";

export const GET_CHILD_PARENT_REQUEST = "GET_CHILD_PARENT_REQUEST";
export const GET_CHILD_PARENT_SUCCESS = "GET_CHILD_PARENT_SUCCESS";
export const GET_CHILD_PARENT_FAILURE = "GET_CHILD_PARENT_FAILURE";

export const GET_COC_REQUEST = "GET_COC_REQUEST";
export const GET_COC_SUCCESS = "GET_COC_SUCCESS";
export const GET_COC_FAILURE = "GET_COC_FAILURE";

export const GET_RAW_MATERIAL_REQUEST = "GET_RAW_MATERIAL_REQUEST";
export const GET_RAW_MATERIAL_SUCCESS = "GET_RAW_MATERIAL_SUCCESS";
export const GET_RAW_MATERIAL_FAILURE = "GET_RAW_MATERIAL_FAILURE";

export const GET_PWM_REQUEST = "GET_PWM_REQUEST";
export const GET_PWM_SUCCESS = "GET_PWM_SUCCESS";
export const GET_PWM_FAILURE = "GET_PWM_FAILURE";

export const GET_EVT_REQUEST = "GET_EVT_REQUEST";
export const GET_EVT_SUCCESS = "GET_EVT_SUCCESS";
export const GET_EVT_FAILURE = "GET_EVT_FAILURE";

export const GET_REPAIR_MAINTAENANCE_REQUEST =
  "GET_REPAIR_MAINTAENANCE_REQUEST";
export const GET_REPAIR_MAINTAENANCE_SUCCESS =
  "GET_REPAIR_MAINTAENANCE_SUCCESS";
export const GET_REPAIR_MAINTAENANCE_FAILURE =
  "GET_REPAIR_MAINTAENANCE_FAILURE";

export const GET_MANUFACTURING_REQUEST = "GET_MANUFACTURING_REQUEST";
export const GET_MANUFACTURING_SUCCESS = "GET_MANUFACTURING_SUCCESS";
export const GET_MANUFACTURING_FAILURE = "GET_MANUFACTURING_FAILURE";

export const GET_ITEMS_DETAILS_BY_DPP_ID_REQUEST =
  "GET_ITEMS_DETAILS_BY_DPP_ID_REQUEST";
export const GET_ITEMS_DETAILS_BY_DPP_ID_SUCCESS =
  "GET_ITEMS_DETAILS_BY_DPP_ID_SUCCESS";
export const GET_ITEMS_DETAILS_BY_DPP_ID_FAILURE =
  "GET_ITEMS_DETAILS_BY_DPP_ID_FAILURE";

export const UPLOADCSV_PASSPORT_REQUEST = "UPLOADCSV_PASSPORT_REQUEST";
export const UPLOADCSV_PASSPORT_SUCCESS = "UPLOADCSV_PASSPORT_SUCCESS";
export const UPLOADCSV_PASSPORT_FAILURE = "UPLOADCSV_PASSPORT_FAILURE";

export const GET_TREE_MAP_REQUEST = "GET_TREE_MAP_REQUEST";
export const GET_TREE_MAP_SUCCESS = "GET_TREE_MAP_SUCCESS";
export const GET_TREE_MAP_FAILURE = "GET_TREE_MAP_FAILURE";